import { Route, Routes, Navigate, useNavigate } from "react-router-dom"
import { useEffect } from 'react'

import LandingPage from "../pages/landingPage"
import Home from "../pages/home"
import AdminsPage from "../pages/adminsPage"
import NotFoundPage from "../pages/notFoundPage"
import Login from "../pages/loginPage"

// Sub-paginas de Home
import DashboardPage from '../pages/dashboardPage'
import MapPage from '../pages/mapPage'
import DevicesPage from '../pages/devicesPage'
//import DeviceDetailsPage from '../pages/devicesDetailsPage'
//import DevicesPage from '../pages/devicesDetailsPage'

export default function AppRoutes() {
  const navigate = useNavigate()

  useEffect(() => {
      const pathname = window.location.pathname
      const user = JSON.parse(localStorage.getItem("user"))
      if (!user?.token || !user?.id) {
        navigate("/")
        //console.log("User not authenticated, redirecting to login.")
      }else if(pathname === "/") {
        navigate("/home")
      }
    }, [navigate])

    
  return (
    <Routes>
      <Route path="/login" element={<Login />}></Route>
      <Route path="/home" element={<Home />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="devices" element={<DevicesPage />} />
        {/*<Route path="devices" element={<DevicesPage />} />*/}
        {/*<Route path="devices/:deviceId" element={<DeviceDetailsPage />} />*/}
        <Route path="*" element={<Navigate to="/home/dashboard" replace />} />
      </Route>
      {<Route path="*" element={<Login />} />}
      
      {/*<Route path="/admins" element={<AdminsPage />} />*/}
      {/*<Route path="*" element={<NotFoundPage />} />*/}
    </Routes>
  )
}